// extracted by mini-css-extract-plugin
module.exports = {"box":"ContentScroll_box__15uex","box2":"ContentScroll_box2__1ukJp"};